/**
 * Created by aaron on 9/22/14.
 */
var _ = require('underscore');
var Backbone = require('backbone');
var sw = require('js/lib/sw');
var actions = require('js/lib/actions');

/**
 *
 * Overrides fetch to emit an event: 'fetchSuccess'. This event is primarily used by CustomMaker
 *
 *
 * @param  {Object} attributes) {                                                                           this._actionHandlerMap [description]
 * @param  {[type]} this);                      Backbone.Model.apply(this, arguments [description]
 * @return {[type]}             [description]
 */
var ShapewaysModel = Backbone.Model.extend({

  // Key Value pairs of methodName (key) and Action type (value)
  // Ex:: 'handlerMethodName' : actions.SOME_ACTION.type
  //
  // 'allHandler': actions.ALL.type
  // ALL is a special type that will be called for every aciton
  actions: {},

  constructor: function(attributes) {

    this.initAttrs = sw.utils.cloneDataObject(attributes);
    this.registerActionHandlers();

    Backbone.Model.apply(this, arguments);
  },

  /**
   * Useful for delegating and undelegating events
   *
   * @return {[type]} [description]
   */
  registerActionHandlers: function registerActionHandlers() {
    // Got pwned by reference equality on the prototype.
    // This is an instance variable so that each model has its
    // own handler map.
    this._actionHandlerMap = {};

    // build the action handler map
    _.each(this.actions, function mapActions(value, key) {
      this._actionHandlerMap[value] = this[key];
    }, this);
  },

  dispatchObserver: function dispatchObserver(action) {
  	var allHandler = this._actionHandlerMap[actions.ALL.type];
  	var handler = this._actionHandlerMap[action.type];

    var newAttrs = {};

  	if(handler) {
	  	newAttrs = _.extend(newAttrs, handler.call(this, this.attributes, action) || {});
	  }

	  if(allHandler) {
	  	newAttrs = _.extend(newAttrs, allHandler.call(this, this.attributes, action) || {});
	  }

    this.set(newAttrs);
  },

  /**
   * Convenience method for getting a list of the action creators this model
   * subscribes to.
   *
   *
   * @return {function}
   */
  getActionCreators: function getActionCreators() {
    return {};
  },

  /**
   * Resets the model to it's initial form
   *
   */
  resetToInitialAttributes: function resetToInitialAttributes() {
    this.set(sw.utils.cloneDataObject(this.initAttrs));
  },

  /**
   * Override fetch in order to emit a custom event called 'fetchSuccess'
   *
   * @see http://backbonejs.org/#Model-fetch
   *
   * @param  {[type]} options [description]
   * @return {[type]}         [description]
   */
  fetch: function fetch(options) {
    options = options || {};

    this._isFetching = true;
    var _this = this;

    var successFunc = options.success || function() {};

    options.success = function(resp) {
      successFunc(resp);

      _this._isFetching = false;
      _this.trigger('fetchSuccess');
    };

    Backbone.Model.prototype.fetch.apply(this, [options]);
  },

  /**
   * Status check whether or not this model is mid-fetch
   *
   * @return {Boolean}
   */
  isFetching: function() {
    return !!this._isFetching;
  }

});


module.exports = ShapewaysModel;
